var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_page_filet_MVP-2_desktop",
    transform: "translate(-1317.000000, -143.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schedule"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334.29684,143.531287 C1334.52982,143.531287 1334.71872,143.720183 1334.71872,143.953161 L1334.71872,150.703145 C1334.71872,150.936123 1334.52982,151.125019 1334.29684,151.125019 L1327.54686,151.125019 C1327.31388,151.125019 1327.12499,150.936123 1327.12499,150.703145 L1327.12499,149.728969 C1327.12499,149.492008 1327.32006,149.301567 1327.55692,149.307198 L1332.00026,149.412975 C1330.91979,147.021669 1328.51523,145.359408 1325.71874,145.359408 C1321.91,145.359408 1318.82813,148.441821 1318.82813,152.250016 C1318.82813,156.058761 1321.91054,159.140625 1325.71874,159.140625 C1327.48026,159.140625 1329.08625,158.481309 1330.30384,157.395794 C1330.47076,157.246964 1330.72582,157.257058 1330.88395,157.415192 L1331.57787,158.109114 C1331.74916,158.280397 1331.74068,158.559621 1331.56091,158.721978 C1330.0149,160.11844 1327.96613,160.968745 1325.71874,160.968745 C1320.90815,160.968745 1317.00753,157.072762 1317.00001,152.263955 C1316.99253,147.469086 1320.89603,143.546324 1325.69086,143.531321 C1328.73472,143.521811 1331.41668,145.072322 1332.98336,147.428471 L1332.90086,143.96322 C1332.89523,143.726328 1333.08571,143.531287 1333.32263,143.531287 L1334.29684,143.531287 Z",
    id: "\\uF01E"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.0cf0d3af.svg";
export { ForwardRef as ReactComponent };